import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Plus, Trash, PencilSimple, X, Buildings } from '@phosphor-icons/react';

export default function BedrijvenPage() {
  const [bedrijven, setBedrijven] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ naam: '', btw: '', email: '', tel: '', adres: '', iban: '', bic: '' });

  const load = () => API.get('/bedrijven').then(r => setBedrijven(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const u = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));
  const resetForm = () => { setForm({ naam: '', btw: '', email: '', tel: '', adres: '', iban: '', bic: '' }); setEditId(null); setShowForm(false); };

  const save = async () => {
    try {
      if (editId) {
        await API.put(`/bedrijven/${editId}`, form);
      } else {
        await API.post('/bedrijven', form);
      }
      resetForm(); load();
    } catch (e) { alert(e.response?.data?.detail || 'Fout'); }
  };

  const startEdit = (b) => { setForm({ naam: b.naam || '', btw: b.btw || '', email: b.email || '', tel: b.tel || '', adres: b.adres || '', iban: b.iban || '', bic: b.bic || '' }); setEditId(b.id); setShowForm(true); };
  const del = async (id) => { if (!window.confirm('Bedrijf verwijderen?')) return; await API.delete(`/bedrijven/${id}`); load(); };

  return (
    <div data-testid="bedrijven-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="page-heading mb-0"><Buildings size={24} className="inline mr-2 text-[#002FA7]" />Bedrijven</h1>
        <button className="btn btn-primary" onClick={() => { resetForm(); setShowForm(true); }} data-testid="new-bedrijf-btn">
          <Plus size={14} weight="bold" /> Nieuw bedrijf
        </button>
      </div>

      {showForm && (
        <div className="section-card mb-5">
          <div className="section-header">
            <span className="section-title">{editId ? 'Bedrijf bewerken' : 'Nieuw bedrijf'}</span>
            <button className="btn btn-ghost btn-sm" onClick={resetForm}><X size={14} /></button>
          </div>
          <div className="p-5">
            <div className="form-grid">
              <div className="form-group form-full">
                <label className="form-label">Bedrijfsnaam</label>
                <input className="field-input" value={form.naam} onChange={u('naam')} data-testid="bedrijf-naam" />
              </div>
              <div className="form-group"><label className="form-label">BTW-nummer</label><input className="field-input" value={form.btw} onChange={u('btw')} /></div>
              <div className="form-group"><label className="form-label">E-mail</label><input className="field-input" value={form.email} onChange={u('email')} /></div>
              <div className="form-group"><label className="form-label">Telefoon</label><input className="field-input" value={form.tel} onChange={u('tel')} /></div>
              <div className="form-group form-full"><label className="form-label">Adres</label><input className="field-input" value={form.adres} onChange={u('adres')} /></div>
              <div className="form-group"><label className="form-label">IBAN</label><input className="field-input" value={form.iban} onChange={u('iban')} /></div>
              <div className="form-group"><label className="form-label">BIC</label><input className="field-input" value={form.bic} onChange={u('bic')} /></div>
            </div>
            <div className="mt-4 flex gap-2">
              <button className="btn btn-primary" onClick={save} data-testid="save-bedrijf-btn">{editId ? 'Bijwerken' : 'Aanmaken'}</button>
              <button className="btn btn-ghost" onClick={resetForm}>Annuleren</button>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {bedrijven.map(b => (
          <div key={b.id} className="section-card">
            <div className="p-5">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="font-bold text-lg">{b.naam || 'Naamloos'}</div>
                  {b.btw && <div className="text-xs text-gray-400 mt-0.5">BTW: {b.btw}</div>}
                </div>
                <div className="flex gap-1">
                  <button className="btn btn-ghost btn-sm" onClick={() => startEdit(b)}><PencilSimple size={14} /></button>
                  <button className="btn btn-ghost btn-sm text-red-400" onClick={() => del(b.id)}><Trash size={13} /></button>
                </div>
              </div>
              {b.adres && <div className="text-sm text-gray-500 mb-1">{b.adres}</div>}
              {b.email && <div className="text-sm text-gray-500">{b.email}</div>}
              {b.tel && <div className="text-sm text-gray-500">{b.tel}</div>}
              {b.iban && <div className="text-xs text-gray-400 mt-2 font-mono">{b.iban}</div>}
            </div>
          </div>
        ))}
        {bedrijven.length === 0 && !showForm && (
          <div className="col-span-full text-center text-gray-400 py-12">
            Geen bedrijven. Klik "Nieuw bedrijf" om er een toe te voegen.
          </div>
        )}
      </div>
    </div>
  );
}
